<template>
  <div id="PersonalCenter" class="wrap">
    <van-nav-bar
      :fixed="true"
      :title="$t('profileMenu.password')"
      left-arrow
      placeholder
      @click-left="onClickLeft"
    />
    <div class="content">
      <div
        class="content-item"
        :class="{ state: NavIndex == index }"
        v-for="(item, index) in Label"
        :key="index"
        @click="MousedownEvent(index, item.url)"
      >
        <div>
          <van-image width="1rem" height="1rem" round :src="item.img" />
          <div class="password-label">{{ $t(item.text) }}</div>
        </div>
        <div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Image,
  Toast
} from "vant";

export default {
  name: "Security",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Image.name]: Image,
    [Toast.name]: Toast,
  },
  data() {
    return {
      Label: [
        // {
        //   id: "1",
        //   // img:require('@/assets/Img/myImg/MyOne.png'),
        //   img: require("@/assets/icon/myInfo/avatar.png"),
        //   image: "https://img.yzcdn.cn/vant/cat.jpeg",
        //   url: "Portrait",
        //   text: `My.PersonalInformation.Page.Avatar`,
        // },
        // {
        //   id: "2",
        //   // img:require('@/assets/Img/myImg/MyTwo.png'),
        //   img: require("@/assets/icon/myInfo/edt.png"),
        //   span: "Aabb2021",
        //   url: "Name",
        //   text: `My.PersonalInformation.Page.Nickname`,
        // },
        // {
        //   id: "3",
        //   // img:require('@/assets/Img/myImg/MyThree.png'),
        //   img: require("@/assets/icon/myInfo/phone.png"),
        //   span: "83131587204",
        //   url: "",
        //   text: `My.PersonalInformation.Page.PhoneNumber`,
        // },
        // {
        //   id: "4",
        //   // img:require('@/assets/Img/myImg/MyFour.png'),
        //   img: require("@/assets/icon/myInfo/bank.png"),
        //   url: "add-bank-card",
        //   text: `My.PersonalInformation.Page.BankAccounts`,
        // },
        {
          id: "5",
          // img:require('@/assets/Img/myImg/MyFive.png'),
          img: require("@/assets/icon/myInfo/pwd.png"),
          url: "Password",
          text: `My.PersonalInformation.Page.Password`,
        },
        {
            id:"6",
            img:require('@/assets/icon/myInfo/pwd.png'),
            url:"PaymentCode",
            text:`My.PersonalInformation.Page.TransactionPassword`,
        },
        // {
        //     id:"7",
        //     img:require('@/assets/Img/myImg/MyFive.png'),
        //     url:"Site",
        //     text:`My.PersonalInformation.Page.ReceivingAddress`,
        // },
      ],
      NavIndex: -1, // 控制选中状态的
    };
  },
  methods: {
    // 返回上一个路由
    onClickLeft() {
      this.$router.go(-1);
    },
    // 标签鼠标按下
    MousedownEvent(num, url) {
      let _this = this;
      this.NavIndex = num;
      setTimeout(function () {
        _this.NavIndex = -1;
      }, 150);
      if (url != "") {
        this.$router.push({ name: url });
      }
    },
  },
};
</script>

<style lang="less">
#PersonalCenter {
  width: 100%;
  height: 100%;
  .logout {
    width: 90vw;
    margin-left: 5vw;
    text-align: center;
    color: #fff;
    line-height: calc(44rem / 16);
    background: var(--nav-background);
    border-radius: calc(22rem / 16);
    position: fixed;
    bottom: 10vh;
  }
  .content {
    width: calc(100% - 2rem);
    padding: 0.125rem 1rem;
    .state {
      background-color: var(--color-primary-soft);
    }
    .content-item {
      height: 3.5rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        > .password-label {
          font-size: 1rem;
        }
        .van-image {
          margin-right: 0.3rem;
        }
      }
      > div:nth-child(2) {
        > span {
          font-size: 0.75rem;
          color: #999;
        }
        .van-icon {
          margin-left: 0.75rem;
          color: #ddd;
        }
      }
    }
  }
}
</style>
